const userListGridConfig = {
    columns: [
        {
            id: 1,
            width: 300,
            selector: 'username',
            name: 'Потребителско име',
            sequenceNumber: 1,
            type: 'string'
        },
        {
            id: 2,
            width: 300,
            selector: 'firstName',
            name: 'Име',
            sequenceNumber: 2,
            type: 'string'
        },
        {
            id: 2,
            width: 300,
            selector: 'lastName',
            name: 'Фамилия',
            sequenceNumber: 3,
            type: 'string'
        },
        {
            id: 4,
            width: 300,
            selector: 'role',
            name: 'Роля',
            sequenceNumber: 4,
            type: 'string',
            filterComponent: 'UserRoleDropdown'
        },
        {
            id: 5,
            width: 125,
            selector: 'active',
            name: 'Акитвен',
            sequenceNumber: 5,
            type: 'boolean'
        }
    ],
    props: {
        headerRowHeight: 50,
        rowHeight: 52,
        tableHeight: 600,
        filterable: true,
        selectableColumn: {
            show: true,
            icon: 'fa fa-user',
            width: 90
        }
    }
};

export default userListGridConfig;
